import IntegrationForm from './IntegrationForm';

export default IntegrationForm;
